import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const pageBackground = "#F4F5F8";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    backgroundColor: pageBackground,
    borderRadius: "6px",
    border: `1px solid ${theme.palette.divider}`,
    "& > .MuiPaper-root": {
      width: "100%",
      backgroundColor: "transparent",
    },
    "& .MuiTableContainer-root": {
      width: "100%",
      maxWidth: "100%",
      overflowX: "scroll !important",
      overflowY: "hidden",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    "& .MuiTable-root": {
      width: "max-content",
      minWidth: "100%",
      borderCollapse: "collapse",
      background: `${pageBackground} !important`,
      backgroundColor: `${pageBackground} !important`,
    },
    "& .MuiTableCell-root": {
      padding: "8px 12px",
      fontSize: "13px",
      textAlign: "right",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontFamily: "Noto Sans Hebrew",
    },
    "& .MuiTableHead-root .MuiTableRow-root": {
      height: "52px",
      opacity: 1,
    },
    "& .MuiTableHead-root .MuiTableCell-head, & [class*='cellHead']": {
      height: "52px !important",
      minHeight: "52px !important",
      maxHeight: "52px !important",
      padding: "0 12px !important",
      boxSizing: "border-box",
      opacity: "1 !important",
      border: "none !important",
      borderBottom: `1px solid ${theme.palette.divider} !important`,
      fontFamily: "Noto Sans Hebrew !important",
      fontWeight: "500 !important",
      fontStyle: "normal !important",
      fontSize: "14px !important",
      lineHeight: "21px !important",
      letterSpacing: "0 !important",
      textAlign: "right !important" as "right",
      whiteSpace: "normal",
      wordBreak: "break-word",
      background: `${pageBackground} !important`,
      backgroundColor: `${pageBackground} !important`,
      color: `${theme.palette.text.primary} !important`,
    },
    "& .MuiTableBody-root .MuiTableRow-root": {
      height: "52px",
      opacity: 1,
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
    "& .MuiTableBody-root .MuiTableCell-root": {
      height: "52px !important",
      minHeight: "52px !important",
      maxHeight: "52px !important",
      padding: "0 12px !important",
      boxSizing: "border-box",
      opacity: "1 !important",
      border: "none !important",
      borderBottom: `1px solid ${theme.palette.divider} !important`,
      backgroundColor: `${theme.palette.background.paper} !important`,
      color: `${theme.palette.secondary.main} !important`,
      fontFamily: "Noto Sans Hebrew !important",
      fontWeight: "400 !important",
      fontStyle: "normal !important",
      fontSize: "14px !important",
      lineHeight: "21px !important",
      letterSpacing: "0 !important",
      textAlign: "right !important" as "right",
    },
    "& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)": {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
    "& .MuiTableBody-root .MuiTableRow-root:hover": {
      backgroundColor: `${theme.palette.background.tableRowHover} !important`,
    },
    "& .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root": {
      backgroundColor: `${theme.palette.background.tableRowHover} !important`,
    },
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "26px",
    minHeight: "26px",
    boxSizing: "border-box",
    opacity: 1,
    gap: "10px",
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    borderRadius: "4px",
    padding: "8px 14px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    whiteSpace: "nowrap",
    fontFamily: "Noto Sans Hebrew",
  },
  contactCell: {
    display: "inline-flex",
    alignItems: "center",
    flexDirection: "row",
    direction: "ltr",
    gap: "6px",
    fontFamily: "Noto Sans Hebrew",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "21px",
    letterSpacing: 0,
    color: `${theme.palette.secondary.main} !important`,
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  avatar: {
    width: "24px !important",
    height: "24px !important",
    fontSize: "11px !important",
    fontWeight: "700 !important",
    color: "#557095 !important",
    backgroundColor: "#DCEFFF !important",
    flexShrink: 0,
  },
}));
